import { useState } from "react";
import { Container, Card, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    const email = e.target.email.value;

    try {
      const res = await fetch("/api/auth/forgot-password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setSuccess(data.message || "If that email exists, a password reset link has been sent to your email.");
      } else {
        setError(data.message || "Failed to send reset email");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      style={{ minHeight: "80vh" }}
      className="d-flex justify-content-center align-items-center py-5"
    >
      <Card className="brutal-card" style={{ width: 450, maxWidth: "100%" }}>
        <Card.Body className="p-5">
          <h2 className="brutal-heading text-center mb-4" style={{ fontSize: "36px" }}>
            FORGOT PASSWORD
          </h2>

          {error && <Alert variant="danger" className="brutal-alert mb-3">{error.toUpperCase()}</Alert>}
          {success && <Alert variant="success" className="brutal-alert mb-3">{success.toUpperCase()}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className="brutal-subheading mb-2">EMAIL ADDRESS</Form.Label>
              <Form.Control
                name="email"
                type="email"
                placeholder="ENTER YOUR EMAIL"
                className="brutal-form-control"
                required
                disabled={loading || !!success}
              />
              <Form.Text className="brutal-text" style={{ fontSize: "12px", marginTop: "4px" }}>
                WE'LL SEND YOU A LINK TO RESET YOUR PASSWORD
              </Form.Text>
            </Form.Group>

            <Button
              type="submit"
              className="brutal-btn brutal-btn-primary w-100 mb-4"
              disabled={loading || !!success}
            >
              {loading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  SENDING...
                </>
              ) : (
                "SEND RESET LINK"
              )}
            </Button>
          </Form>

          <div className="text-center">
            <Button
              variant="link"
              className="brutal-link p-0"
              onClick={() => navigate("/login")}
              disabled={loading}
              style={{ textDecoration: "underline", textDecorationThickness: "2px" }}
            >
              BACK TO LOGIN
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
